'use client'

import { useRef, useState } from 'react'

export function VideoPlayer({ src, poster }: { src: string; poster?: string }) {
  const videoRef = useRef<HTMLVideoElement>(null)
  const [playing, setPlaying] = useState(false)

  const handleOverlayClick = () => {
    videoRef.current?.play()
  }

  return (
    <div className="relative rounded-2xl overflow-hidden border border-border shadow-xl">
      {/* biome-ignore lint/a11y/useMediaCaption: VSL video does not have captions */}
      <video
        ref={videoRef}
        className="w-full"
        controls
        preload="metadata"
        poster={poster}
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
      >
        <source src={src} type="video/mp4" />
      </video>

      {!playing && (
        <button
          type="button"
          aria-label="Play video"
          className="absolute inset-0 hidden md:flex items-center justify-center cursor-pointer group w-full"
          onClick={handleOverlayClick}
        >
          <svg
            viewBox="0 0 24 24"
            className="h-20 w-20 text-white/40 transition-all duration-200 group-hover:text-white/60 group-hover:scale-110 drop-shadow-lg"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M8 5v14l11-7z" />
          </svg>
        </button>
      )}
    </div>
  )
}
